import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BookOpen } from 'lucide-react';
import { api, mediaUrl } from '../services/api';

export default function ProductCatalogsPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [catalogs, setCatalogs] = useState([]);

  useEffect(() => {
    let mounted = true;
    api.getProductCatalogs()
      .then((res) => {
        if (mounted) setCatalogs(Array.isArray(res?.data) ? res.data : []);
      })
      .catch(() => mounted && setCatalogs([]))
      .finally(() => mounted && setLoading(false));
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <main className="min-h-[70vh] bg-gray-50" dir="rtl">
      <section className="border-b border-gray-200 bg-white">
        <div className="pp-container py-8">
          <div className="inline-flex items-center gap-2 rounded-full bg-blue-50 px-3 py-1 text-xs font-bold text-[#005bbb]">
            <BookOpen className="h-4 w-4" />
            کاتالوگ محصولات
          </div>
          <h1 className="mt-4 text-2xl font-extrabold text-slate-900 sm:text-3xl">کاتالوگ محصولات</h1>
        </div>
      </section>

      <section className="pp-container py-10">
        {loading ? (
          <div className="rounded-2xl border border-gray-200 bg-white p-6 text-sm text-gray-500">در حال بارگذاری...</div>
        ) : catalogs.length ? (
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
            {catalogs.map((item) => (
              <button
                key={item.id}
                type="button"
                onClick={() => navigate(`/product-catalogs/${item.id}`)}
                className="group flex min-h-36 flex-col items-center justify-center gap-3 rounded-2xl border border-gray-200 bg-white p-4 text-center shadow-sm transition hover:border-[#005bbb] hover:shadow-lg"
              >
                {item.logo_url ? (
                  <img src={mediaUrl(item.logo_url)} alt={item.title} className="h-16 w-full object-contain" />
                ) : (
                  <span className="grid h-16 w-16 place-items-center rounded-2xl bg-blue-50 text-[#005bbb]">
                    <BookOpen className="h-7 w-7" />
                  </span>
                )}
                <span className="line-clamp-2 text-sm font-extrabold text-slate-800 group-hover:text-[#005bbb]">{item.title}</span>
              </button>
            ))}
          </div>
        ) : (
          <div className="rounded-2xl border border-gray-200 bg-white p-6 text-sm text-gray-500">هنوز کاتالوگی ثبت نشده است.</div>
        )}
      </section>
    </main>
  );
}
